import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumValue'
})
export class EnumValuePipe implements PipeTransform {

  transform(value: any, args: any):any{
    const indexOf = Object.keys(args).indexOf(value);
    return Object.values(args)[indexOf];
  }

}
